import { render } from "./WidgetTable.vue?vue&type=template&id=62520740&scoped=true"
import script from "./WidgetTable.vue?vue&type=script&lang=js"
export * from "./WidgetTable.vue?vue&type=script&lang=js"

import "./WidgetTable.vue?vue&type=style&index=0&id=62520740&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62520740"],['__file',"src/components/Charts/WidgetTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62520740"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62520740', __exports__)) {
    api.reload('62520740', __exports__)
  }
  
  module.hot.accept("./WidgetTable.vue?vue&type=template&id=62520740&scoped=true", () => {
    api.rerender('62520740', render)
  })

}


export default __exports__